import React from 'react'
import BlogPost from './BlogPost'

export default function ListeningOverSpeaking() {
  return (
    <BlogPost
      translationKey="listeningOverSpeaking"
      seoTitle="잘 말하는 것보다 잘 듣는 것 | Hyunjin Jae"
      seoDescription="리더에게 필요한 것은 말하기보다 듣기일 수 있다는 생각을 담은 글입니다."
      seoKeywords="리더십, 커뮤니케이션, 경청, 소통, leadership, communication, listening"
      seoTags={['leadership', 'communication', 'listening']}
    />
  )
}
